import { EpimsBaseEntityDto } from './epim-base.dto';
export class StakeholderSubGroupDto extends EpimsBaseEntityDto {

    StakeholderSubGroupId: string;

    StakeholderSubGroupName: string;
    StakeholderGroupId: string;

 

}